module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAMAAAAYoR5yAAAAOVBMVEUAAAAAAP8AVf8ASf8ATusTS+wOUvELT+wPUO0NUe0QT/EQTu8QUO8RT+4OUO8QTu8PT+4RT+4RUO4oXjBJAAAAE3RSTlMAAQMHDSk1RFNibm9zen+NlZiZ4vCo8wAAAEBJREFUCNdj4OFnZYACISEBNjhTSJAdzhQS4mCEM4U4meBMIW5mOFOIlwXOFOLDxkQo4GLGNAxuBcJiuHMQjgQAWz0Gvuw7iqUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_arrow1.png
// module id = chCY
// module chunks = 1